module.exports = __webpack_public_path__ + "img/r6.7656c24c.jpg";